export default "/images/0d8be5b5310517614db6b11f737aa224.avif";